/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Upload_MobisInputs */

const en_features_upload_mobis = /** @type {(inputs: Features_Upload_MobisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MOBIs`)
};

const es_features_upload_mobis = /** @type {(inputs: Features_Upload_MobisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MOBIs`)
};

/**
* | output |
* | --- |
* | "MOBIs" |
*
* @param {Features_Upload_MobisInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_upload_mobis = /** @type {((inputs?: Features_Upload_MobisInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Upload_MobisInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_upload_mobis(inputs)
	return en_features_upload_mobis(inputs)
});